import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const Skills = () => {
  const { ref, inView} = useInView({
    threshold: 0.2,
  });

  // total Clients state
  const [client, setClient] = useState(0);

  // work completed state
  const [workcomp, setWorkComp] = useState(0);

  // ongoing job state
  const [ongoing, setOngoing] = useState(0);

  // location served state
  const [locationserved, setLocationserved] = useState(0);
  

  useEffect(()=>{
    if(inView) {
      setTimeout(()=>{
        if(client < 8){
          setClient(client+8);
        }
        if(workcomp < 15){
          setWorkComp(workcomp+15);
        }
        if(ongoing < 20){
          setOngoing(ongoing+1);
        }
        if(locationserved< 15){
          setLocationserved(locationserved+1);
        }
      }, 10);
    } else {
      setClient(0);
      setWorkComp(0);
      setOngoing(0);
      setLocationserved(0);
    }
  },[inView, client, workcomp, ongoing, locationserved]);

  const styles = {
    path: {
      sroke: '#111111'
    },
    trail: {
      stroke: '#eeeeee'
    },
    text: {
      fill: '#111111',
      fontSize: '24px',
    },
  };

  return (
    <motion.section ref={ref}                                                           
     variants={fadeIn('up')}
    initial='hidden'
    whileInView={'show'}
    viewport={{once:false, amount: 0.1}}
    className='section font-primary'>
      <div className='container mx-auto'>
        <div className='flex flex-col xl:flex-row justify-around items-center gap-y-12 lg:gap-x-6'>
          <div className='w-[150px] lg:w-[180px] flex flex-col items-centre gap-y-4'>
            <CircularProgressbar strokeWidth={1} value={client}
            styles={styles} text={`${client}00+`} />
            <div className='uppercase font-dark tracking-[1.2px] text-centre'>Clients Served</div>
          </div>

          <div className='w-[150px] lg:w-[180px] flex flex-col items-centre gap-y-4'>
            <CircularProgressbar strokeWidth={1} value={workcomp}
            styles={styles} text={`${workcomp}00+`} />
            <div className='uppercase font-dark tracking-[1.2px] text-centre'>Work Completed</div>
          </div>

          {/* <div className='w-[150px] lg:w-[275px] flex flex-col items-centre gap-y-6'>
            <CircularProgressbar strokeWidth={1} value={ongoing}
            styles={styles} text={`${ongoing}+`} />
            <div className='uppercase font-dark tracking-[1.2px] text-centre '>Ongoing Jobs</div>
          </div> */}

          <div className='w-[150px] lg:w-[180px] flex flex-col items-centre gap-y-4'>
            <CircularProgressbar strokeWidth={1} value={locationserved}
            styles={styles} text={`${locationserved}0+`} />
            <div className='uppercase font-dark tracking-[1.2px] text-centre'>Location served</div>
          </div>

        </div>
      </div>
      
    </motion.section>
    
  );
};

export default Skills;
